// extracted by mini-css-extract-plugin
module.exports = {"page":"InternalDashboard_page__3BcFZ","metricContainer":"InternalDashboard_metricContainer__1iQYT","tableContainer":"InternalDashboard_tableContainer__jPB7N"};